import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { Nullable } from 'cng-common/models/utils'
import { IDataSource } from 'core-components/types/ICrudHelpers'

// Core Contact Types
export interface IPartnerContact {
  UID: string
  ContactId: string
  Email: string
  EntryId: number
  FYear: number
  FirstName?: string
  FullName?: string
  Image: Nullable<string>
  LastName?: string
  PR_HP_Role: string
  PartnerId: string
  PartnerName: string
  PrimaryJobRole: Nullable<string>
  ProgramType: ProgramTypes
  Roles: string
  Salutation: Nullable<string>
  ShortBio?: string
}

// Contact Search Types
export interface IContactSearchItem {
  contactId: string
  entryId: number
  firstName: string
  lastName: string
  fullName: string
  email: string
  isInContacts: boolean
  roles: string
}

// Data Source Config
export const CONTACTS_DATA_SOURCE: IDataSource = {
  formId: '700',
  code: 'PartnerContacts',
}
